/**
 * 材料台账管理路由配置
 */
const materialRoute = {
  path: 'material',
  name: 'material',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'list',
      name: 'materialList',
      component: () => import('./index.vue'),
      meta: {
        navtabTitle: '材料台账管理',
        isCache: true,
        ignoreDiff: [],
        isIframe: false
      }
    }
  ]
};

export default materialRoute;
